import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.btn = this.el.querySelector('.selectBtn')
    this.options = this.el.querySelectorAll('.selectOpt')

    this.initEventlisteners()
  }

  initEventlisteners() {
    this.btn.addEventListener('click', () => {
      this.toggleDropdown()
    })

    this.options.forEach((opt) => {
      opt.addEventListener('click', () => {
        this.setOption(opt)
      })
    })
  }

  setOption(el) {
    this.options.forEach((opt) => {
      opt.classList.remove('--active')
    })
    el.classList.add('--active')
  }



  toggleDropdown(){
    this.el.style.setProperty('--filter-list-height', `${this.el.querySelector('.c-list-wrap').scrollHeight}px`);
    this.btn.classList.toggle('--active')
  }
}
